<template>
	<div v-if="watch.SKU == proSlug" class="page-wrapper watchcard">
        <div class="page-grid-wrapper watch-card-wrapper" v-if="!authUser && watch.MembersAreaOnly === 0" :key="watch.SKU">
            <div class="page-grid-full-screen"> 
                <article class="grid-container columns-two">
                    <section class="section1">
                        <div class="watch-card-gallery">
                          <div v-if="isGalleryLoading" class="gallery-spinner">
                                <span class="loader"></span>
                                <p>Loading {{ watch.Name }} gallery...</p>
                            </div>
                            <div v-else class="watch-gallery-item">
                                <div id="card-slider">
                                    <!-- MAIN IMAGE -->
                                    <a 
                                      v-if="images.length"
                                      :href="`/watches/gallery/NW-${watch.SKU}/gallery-large-image/${images[0].name}`"
                                      class="MagicZoom"
                                      id="watchimage"
                                      data-options="cssClass: mz-show-arrows no-expand-thumbnails; zoomMode: off; hint: off; lazyZoom: true;"
                                    >
                                        <img :src="`/watches/gallery/NW-${watch.SKU}/gallery-small-image/${images[0].name}`" />
                                    </a>

                                    <!-- THUMBNAILS -->
                                    <!-- <div class="space-helper"></div> -->
                                    <div
                                        class="MagicScroll"
                                        data-options="arrows:inside; items:3; step:1;"
                                        style="height:100%; padding-top:25px;"
                                    >
                                      <a
                                        v-for="(image, index) in images"
                                        :key="index"
                                        data-zoom-id="watchimage"
                                        :href="`/watches/gallery/NW-${watch.SKU}/gallery-large-image/${image.name}`"
                                        :data-image="`/watches/gallery/NW-${watch.SKU}/gallery-small-image/${image.name}`"
                                      >
                                          <img :src="`/watches/gallery/NW-${watch.SKU}/thumb-image/${image.name}`" />
                                      </a>
                                  </div>
                                </div>
                            </div> 
                        </div>
                    </section>

                    <section class="section2">
                        <div class="watch-card-details">
                            <h2>{{ watch.Name }}<br>{{ watch.FullDetailsName }}</h2>
                            <template  v-if='watch.SKU'>
                              <div style="margin: -35px 0px 35px 0; font-size: 0.8rem;">Stock No: NW-{{ watch.SKU }}</div>
                            </template>
                            <article class="grid-container columns-two columns-two-mobile bordered no-gap-column" style="top: 0;"> 
                                <section>
                                    <span v-if="watch.StatusName === 'Sold'">Sold</span>
                                    <span v-else class="status">In Stock<br>
                                        <!-- <small v-if='watch.WatchLocation' style="text-transform: initial;">In our <router-link :to="{ path: '/locations', hash: '#' + watch.WatchLocation }" style="color: #ae9248; text-transform: capitalize; ">{{watch.WatchLocation}}</router-link> boutique</small> -->
                                      <small v-if="watch.WatchLocation" style="text-transform: initial;">
                                          In our
                                          <template v-if="watch.WatchLocation === 'UAE'">
                                            <span>
                                              {{ watch.WatchLocation }}
                                            </span>
                                            office
                                          </template>
                                          <template v-else>
                                            <router-link
                                              :to="{ path: '/locations', hash: '#' + watch.WatchLocation }"
                                              style="color: #ae9248;"
                                            >
                                              {{ watch.WatchLocation }}
                                            </router-link>
                                            boutique
                                          </template>
                                        
                                        </small>
                                      </span>
                                </section>
                                <section>
                                  <span v-if="watch.isPOA" class="status">POA</span>
                                  <span v-else class="price">
                                    <span class="currency">{{ watch.currencySymbol }}</span>
                                    {{ watch.displayPrice }}
                                    <br>
                                    <span class="exc-taxes" v-if="watch.showExcTaxes"><small>&nbsp;exc.&ensp;taxes</small></span>
                                  </span>
                                </section>  
                            </article>

                            <!-- Contact section -->    
                              <article class="grid-container columns-two columns-two-mobile" style="grid-template-columns: 2fr 1fr 2fr; margin: 35px 0 -15px 0;">      
                                <section>
                                    <button class="center clean-link" type="submit" style="text-align: right !important;">

                                    <a v-if="contactDetails.whatsappLink"
                                      :href="contactDetails.whatsappLink"
                                      target="_blank" style="color: #ae9248 !important;"><img style="filter: invert(0%);" src="/images/icons/whatsapp-gold.svg">
                                      WhatsApp us
                                    </a>

                                    </button>
                                </section>
                                <section>
                                    <button class="center clean-link" type="submit">
                                        <a v-if="contactDetails.phoneNumber"
                                          :href="'tel:' + contactDetails.phoneNumber" style="color: #ae9248 !important;"><img style="filter: invert(0%);" src="/images/icons/phone-gold.svg"></img>
                                          Call us
                                        </a>
                                    </button>
                                </section>
                                <section>
                                  <span @click="toggleArticles" class="center clean-link" style="text-align: left !important; top: 4px !important; position: relative;">
                                    <a class="show-more" v-if="showArticles" >Hide Form</a>
                                    <a class="show-more" v-else><img style="filter: invert(0%); height: 18px; vertical-align: text-top; margin-right: 10px;" src="/images/icons/write-to-us-gold.svg">Write to Us</a>
                                  </span>
                                </section>
                            </article>
                            <!-- <article class="toggle-arrow center">
                                <span @click="toggleArticles" >
                                    <a class="show-more" v-if="showArticles" >Hide Form</a>
                                    <a class="show-more" v-else>Write to Us</a>

                                </span>
                            </article> -->
                            <article style="margin-top: 0;" v-show="showArticles">
                                <section>
                                    <EnquiryForm :Model="watch.Model" :SKU="watch.SKU" formOrigin="Detail Page Enquiry " ></EnquiryForm>
                                </section>
                            </article>

                        <!-- End Contact section --> 

                            <p class="show-more-container vhtml" :class="{ 'expanded': expanded }" ref="textElement" v-html="watch.Description"></p>
                            <a class="show-more" v-if="!expanded && isLongDescription" @click="expandText">Read more</a>
                            <a class="show-more" v-if="expanded" @click="contractText">Show less</a>

                                <!-- 2026 UPDATE -->
                                 <!-- <article class="grid-container columns-one specification" style="grid-template-columns: 1fr;">
                                  <div style="border-top: none; border-left: none; border-right: none; border-bottom: 1px solid #d2d2d2; padding: 9px 0;">
                                    <div style="display: inline-block; margin: 0px 35px;" v-if='watch.CertOfAuth == "Yes"'>
                                        <div>Certificate of Authenticity: {{ watch.CertOfAuth }}</div>
                                    </div>
                                    <div style="display: inline-block; margin: 0px 35px;" v-if='watch.Warranty == "Yes"'>
                                        <div>Warranty: {{ watch.Warranty }}</div>
                                    </div>
                                    <div style="display: inline-block; margin: 0px 35px;" v-if='watch.Year'>
                                      <div>Year: {{ watch.Year }}</div>
                                    </div>
                                    <div style="display: inline-block; margin: 0px 35px;"  v-if='watch.Papers == "Yes"'>
                                      <div>Papers {{ watch.Papers }}</div>
                                    </div>
                                     <div style="display: inline-block; margin: 0px 35px;"  v-if='watch.Box == "Yes"'>
                                      <div>Papers {{ watch.Box }}</div>
                                    </div>
                                  </div>
                            </article> -->

                            <article class="grid-container columns-two specification">
                                <section class="section1">
                                    <div class="table-wrapper product-features left">
                                        <div class="div-table">
                                            <div class="div-row"  v-if='watch.SKU'>
                                            <div  class="div-cell">Stock No:</div><div  class="div-cell">NW-{{ watch.SKU }}</div>
                                            </div>
                                            <div class="div-row"  v-if=' watch.Box'>
                                            <div  class="div-cell">Box </div><div  class="div-cell">{{ watch.Box }}</div>
                                            </div><div class="div-row"  v-if='watch.Papers == "Yes"'>
                                            <div  class="div-cell">Papers</div><div  class="div-cell">{{ watch.Papers }}</div>
                                            </div>
                                            <div class="div-row"  v-if='watch.CertOfAuth == "Yes"'>
                                                <div  class="div-cell">Certificate of Authenticity</div><div  class="div-cell">{{ watch.CertOfAuth }}</div>
                                            </div>
                                            <div class="div-row"  v-if='watch.Warranty == "Yes"'>
                                                <div  class="div-cell">Warranty</div><div  class="div-cell">{{ watch.Warranty }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </section>

                                <section class="section2">
                                    <div class="table-wrapper product-features right">
                                        <div class="div-table">
                                        <div class="div-row" v-if='watch.WaterResistance'>
                                            <div  class="div-cell">Water Resistant:</div> <div  class="div-cell">{{ watch.WaterResistance }}</div>
                                            </div><div class="div-row"  v-if='watch.Strap'>
                                            <div  class="div-cell">Strap:</div> <div  class="div-cell">{{ watch.Strap }}</div>
                                            </div><div class="div-row"  v-if='watch.Buckle'>
                                            <div  class="div-cell">Buckle:</div><div  class="div-cell">{{ watch.Buckle }}</div>
                                            </div><div class="div-row"  v-if='watch.Year'>
                                            <div  class="div-cell">Year: </div><div  class="div-cell">{{ watch.Year }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </article>

                        </div>
                    </section>
                </article>
            </div>
        </div>
        <div v-else-if="!authUser && watch.MembersAreaOnly === 1" >    
            <div class="page-grid watch-card-wrapper" :key="watch.SKU">
                <div v-if="!authUser && watch.MembersAreaOnly === 1" :key="watch.SKU">
                    <div>
                        <h2>Content of this page is available to members only.</h2><br />
                        <router-link to="register"><span class="no-mobile">Register</span></router-link>
                    </div>
                </div>
			    <article class="grid-container columns-two">
                    <section class="section1">
                        <div class="watch-card-gallery">
                            <div class="watch-gallery-item">
                            <div id="card-slider">
                                    <!-- FIRST IMAGE IN THE GALLERY --><!-- ALL GALLERY IMAGES -->
                                <a :href="'/watches/gallery/NW-' + watch.SKU + '/gallery-large-image/' + images[0].name" class="MagicZoom" id="watchimage" data-options="cssClass: mz-show-arrows no-expand-thumbnails; zoomMode: off; hint: off;"><img :src="'/watches/gallery/NW-' + watch.SKU + '/gallery-small-image/' + images[0].name"></a>
                                <a v-for="image in images" data-zoom-id="watchimage" :href="'/watches/gallery/NW-' + watch.SKU + '/gallery-large-image/' + image.name" :data-image="'/watches/gallery/NW-' + watch.SKU + '/gallery-small-image/' + image.name"><img style=" width: 70px;" :src="'/watches/gallery/NW-' + watch.SKU + '/thumb-image/' + image.name"></a>
                                
                                </div>
                            </div> 
                        </div>
                                    
                    </section>
                    <section class="section2">
                        <div class="watch-card-details">
                            <h2>{{ watch.Name }}</h2>
                            <article>
                                <section>
                                    <p>{{ watch.Description }}</p>
                                </section>
                                <section >
                                    <div class="table-wrapper product-features left">
                                        <div class="div-table">
                                            <div class="div-row"  v-if='watch.SKU'>
                                            <div  class="div-cell">Stock No:</div><div  class="div-cell">NW-{{ watch.SKU }}</div>
                                            </div>
                                            <div class="div-row"  v-if='watch.Box'>
                                            <div  class="div-cell">Box </div><div  class="div-cell">{{ watch.Box }}</div>
                                            </div><div class="div-row"  v-if='watch.Papers == "Yes"'>
                                            <div  class="div-cell">Papers</div><div  class="div-cell">{{ watch.Papers }}</div>
                                            </div>
                                            <div class="div-row"  v-if='watch.CertOfAuth == "Yes"'>
                                                <div  class="div-cell">Certificate of Authenticity</div><div  class="div-cell">{{ watch.CertOfAuth }}</div>
                                            </div>
                                            <div class="div-row"  v-if='watch.Warranty == "Yes"'>
                                                <div  class="div-cell">Warranty</div><div  class="div-cell">{{ watch.Warranty }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="table-wrapper product-features right">
                                        <div class="div-table">
                                        <div class="div-row" v-if='watch.WaterResistance'>
                                            <div  class="div-cell">Water Resistant:</div> <div  class="div-cell">{{ watch.WaterResistance }}</div>
                                            </div><div class="div-row"  v-if='watch.Strap'>
                                            <div  class="div-cell">Strap:</div> <div  class="div-cell">{{ watch.Strap }}</div>
                                            </div><div class="div-row"  v-if='watch.Buckle'>
                                            <div  class="div-cell">Buckle:</div><div  class="div-cell">{{ watch.Buckle }}</div>
                                            </div><div class="div-row"  v-if='watch.Year'>
                                            <div  class="div-cell">Year: </div><div  class="div-cell">{{ watch.Year }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <h2 class="status" style="margin-top: 2.5vh;" v-if="watch.StatusName === 'Sold'">POA</h2>
                                    <h2 class="price" style="margin-top: 2.5vh;" v-else-if="Number(watch.Price) > Number(siteSettings.poa_price_tag)">POA</h2>
                                    <h2 class="price" style="margin-top: 2.5vh;" v-else><span class="currancy" style="">£</span>
                                    <span  class="price">{{ $formatNumber(watch.Price) }}</span></h2>          
                                </section>
                                <section>
                                    <span class="large">Enquire about this watch</span>
                                                    
                                    <h2></h2>
                                    <EnquiryForm :Model="watch.Model" :SKU="watch.SKU" formOrigin="Detail Page Enquiry " ></EnquiryForm>

                                </section>    
                                <section>                   
                                    <a 
                                      :href="'https://api.whatsapp.com/send?phone=' 
                                        + londonboutique.WhatsAppNumber 
                                        + '&text=' 
                                        + encodeURIComponent('Hello!\nI am enquiring about ' + watch.Name + ' - ' + watch.SKU)">
                                        <img src="/images/icons/whatsapp-grey.svg"> 
                                        <span>WhatsApp us</span>
                                    </a>                        
                                    <a class="phone_number" :href="'tel:' + londonboutique.PhoneNumber">
                                        <img src="/images/icons/phone-grey.svg">
                                        <span>Call us</span>
                                    </a>
                                </section>
                                <br><br>                                <br><br>
                            </article>
                        </div>
                    </section>
                </article>
            </div>          
        </div>
        
        <WatchVariants :manufacturername="watch.ManufacturerName" :model="watch.Model" :sku="watch.SKU" :movement="watch.Movement" :material="watch.Material" :gender="watch.Gender"></WatchVariants>

    </div>
</template>

<script>

import EnquiryForm from '../components/EnquiryForm.vue';
import WatchVariants from '../components/WatchVariants.vue';
import { mapGetters } from "vuex";
// import store from "../store/index";
import axios from 'axios';

export default {
  name: 'Otherwatchcard',
  
  components: {
    EnquiryForm,
    WatchVariants,
  },
  props: ["manufacturername", "model", "sku", "movement", "material", "gender"],
  
  data() {
    return {
      showArticles: false,
      watch: [],
      images: [],
      proSlug: null, // Initialize proSlug as null
      londonboutique: [],
      expanded: false,
      isLongDescription: false,
      axiosCancelToken: null,
      isGalleryLoading: true, // spinner state
    };
  },
  
  created() {
    // Check the route parameter on component creation
    if (this.$route.params.watchSKU) {
      this.proSlug = this.$route.params.watchSKU; // Set proSlug from route
      this.loadWatch(this.proSlug); // Fetch watch data
    }
  },
  
  watch: {
    '$route.params.watchSKU' (newSlug) {
      this.proSlug = newSlug; // Update proSlug when the route changes
      this.loadWatch(newSlug); // Fetch new watch data
    },
  },

  mounted() {
    this.getLondonBoutique(); // Fetch London boutique data
    this.checkDescriptionLength(); // Check if text is long on component mount
    window.addEventListener('resize', this.handleResize); // Listen for window resize
  },
  

  methods: {        
    async loadWatch(sku) {
      if (this.axiosCancelToken) {
        this.axiosCancelToken.cancel("Operation canceled due to new request.");
      }
      this.axiosCancelToken = axios.CancelToken.source();

      try {
        // 1️ Load details only
        const responseDetails = await this.$axios.get(
          `/api/singlewatch/${sku}/details`,
          { cancelToken: this.axiosCancelToken.token }
        );

        this.watch = responseDetails.data[0];
        
        this.$nextTick(() => {
          this.checkDescriptionLength();
        });
        this.$emit("route-data-ready"); // tells App.vue to hide loader
        // 2️ Load gallery asynchronously, after .section2 is rendered
        this.loadGallery(sku);
      } catch (err) {
        if (!axios.isCancel(err)) console.error("Failed to load watch:", err);
      }
    },
    
    async loadGallery(sku) {
      try {
        const responseImages = await this.$axios.get(
          `/api/singlewatch/${sku}/images`,
          { cancelToken: this.axiosCancelToken.token }
        );
        this.images = responseImages.data[0];

        this.isGalleryLoading = true;

        this.$nextTick(() => {
          this.waitForTwoImages();
        });
      } catch (err) {
        if (!axios.isCancel(err)) console.error("Failed to load gallery:", err);
      }
    },

    waitForTwoImages() {
      if (!this.images.length) {
        this.isGalleryLoading = false;
        return;
      }

      const toLoad = this.images.slice(0, 2); // preload first 2
      let loadedCount = 0;

      toLoad.forEach((img) => {
        const loader = new Image();
        loader.src = `/watches/gallery/NW-${this.watch.SKU}/gallery-small-image/${img.name}`;
        loader.onload = loader.onerror = () => {
          loadedCount++;
          if (loadedCount >= toLoad.length) {
            this.isGalleryLoading = false;
            // Initialize gallery when 2 images are ready
            this.$nextTick(() => {
              this.initGallery();
            });
          }
        };
      });
      // fallback: hide spinner & init gallery anyway after 5s
      setTimeout(() => {
        if (this.isGalleryLoading) {
          this.isGalleryLoading = false;
          this.initGallery();
        }
      }, 5000);
    },

    initGallery() {
        MagicZoom.refresh();
        MagicScroll.refresh();
      },

    getLondonBoutique(address) {
      this.$axios.get(address || "/api/londonboutique")
        .then(response => {
          this.londonboutique = response.data.data[0];
        });
    },

    handleResize() {
      this.checkDescriptionLength(); // Check description length on resize
    },

    checkDescriptionLength() {
      if (this.watch.Description) {
        this.isLongDescription = this.watch.Description.length > 300; // adjust threshold as needed
      } else {
        this.isLongDescription = false;
      }
    },

    expandText() {
      this.expanded = true;
    },
    contractText() {
      this.expanded = false;
    },
    toggleArticles() {
      this.showArticles = !this.showArticles;
    },
  },

  computed: {
    ...mapGetters("auth", ["authUser"]),
    isExtended() {
      return this.expanded;
    },
    contactDetails() {
      let boutique = null;

      switch (this.watch?.WatchLocation) {
        case 'London':
          boutique = this.londonboutique;
          break;

        case 'Geneva':
          boutique = this.genevaboutique;
          break;

        case 'UAE':
          boutique = this.londonboutique; // tight to London for now
          break;

        default:
          boutique = null;
      }

      if (!boutique) {
        return {
          whatsappNumber: null,
          whatsappLink: null,
          phoneNumber: null
        };
      }

      const whatsappNumber = boutique?.WhatsAppNumber || null;
      const phoneNumber = boutique?.PhoneNumber || null;

      let whatsappLink = null;

      if (whatsappNumber) {
        const message = `Hello!\nI am enquiring about ${this.watch.Name} - ${this.watch.SKU}`;
        whatsappLink = `https://api.whatsapp.com/send?phone=${whatsappNumber}&text=${encodeURIComponent(message)}`;
      }

      return {
        whatsappNumber,
        whatsappLink,
        phoneNumber
      };
    }
  },
 
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
    if (this.axiosCancelToken) {
      this.axiosCancelToken.cancel(
        "Component destroyed, canceling ongoing requests."
      );
    }
  },
};

</script>
